// Clé Google Maps JS utilisée par les pages qui affichent une carte.
//
// Une clé "browser" est nécessairement publique (elle part dans le bundle) :
// ce n'est pas un secret, sa protection est la restriction par référent HTTP
// côté console Google. On la centralise ici pour n'avoir qu'un seul endroit à
// modifier lors d'une rotation, au lieu d'une copie par composant.
//
// REACT_APP_GOOGLE_MAPS_KEY est lu en priorité, mais CRA inline les variables
// au moment du build : le Dockerfile ne les reçoit pas (env_file de compose
// n'agit qu'au runtime). D'où la valeur de repli, qui garde les cartes
// fonctionnelles tant que le build n'est pas paramétré.
const GOOGLE_MAPS_KEY =
  process.env.REACT_APP_GOOGLE_MAPS_KEY ||
  "AIzaSyBzXYw_nDxw_-tTWeh-2VZv_yJX8dREnXg";

export default GOOGLE_MAPS_KEY;
